import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignService } from 'src/app/_services/campaign.service';
import { TransactionService } from 'src/app/_services/transaction.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
    selector: 'app-bulk-email-campaign',
    templateUrl: './bulk-email-campaign.component.html',
    styleUrls: ['./bulk-email-campaign.component.scss'],
    standalone: false
})
export class BulkEmailCampaignComponent implements OnInit {
  @Input() campaign_id: number;
  @Input() totalTarget: number;
  @Input() type: string;
  @Input() payload: any;
  isLoadingBulkReveal: boolean = false;
  @Input() candidateNumber: string;
  @Input() responseLength: number;
  constructor(private modalService: NgbModal, private router: Router, private emailCampaignService: CampaignService, private transactionService: TransactionService, private localstorageservice: LocalStorageService) { }

  ngOnInit() {
  }

  dismiss() {
    this.modalService.dismissAll();
  }

  redirectToEmailCampaign() {
    if (this.type == 'Bulk') {
      this.isLoadingBulkReveal = true
      this.emailCampaignService.bulkReveal(this.payload).subscribe((res: any) => {
        this.fetchcredits();
        if (res && res.status == 'success') {
          this.isLoadingBulkReveal = false;
          this.dismiss();
          this.router.navigateByUrl(`email-campaign/target-listing/${this.campaign_id}`);
        }
      })
    } else {
      this.dismiss();
      this.router.navigateByUrl(`email-campaign/target-listing/${this.campaign_id}?source=aisourcing&candidate=${this.candidateNumber}`);
    }

  }

dismissLater() {
    this.isLoadingBulkReveal = true
      this.emailCampaignService.bulkReveal(this.payload).subscribe((res: any) => {
        this.fetchcredits();
        if (res && res.status == 'success') {
          this.isLoadingBulkReveal = false;
          this.dismiss();
        }
      })
}

  /**Get the latest credits available */
  fetchcredits() {
    this.transactionService.fetchcurrentplandetails(this.localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == 'success') {
        let userData = this.localstorageservice.getItem('userdata');
        userData['balancebasiccontactenrichmentcredits'] = res.data.balancebasiccontactenrichmentcredits;
        this.localstorageservice.setItem('userdata', userData);
        this.transactionService.createPaymentData();
      }
    })
  }

}
